import { ApolloLink } from "@apollo/client";

import type { ExecutionResultWithAuthData } from "@shared/types/executionResultWithAuthData";
import { isDevelopment } from "@shared/utils/fullscriptEnv/fullscriptEnv";
import { turnOffErrorReporting } from "@shared/utils/initSentry/filters/turnErrorsOff/turnErrorsOff";

interface Params {
  roleId?: string;
}

export const getAuthorizedAndValidDataLink = ({ roleId }: Params = {}) => {
  return new ApolloLink((operation, forward) => {
    return forward(operation).map((result: ExecutionResultWithAuthData) => {
      /**
       * This specifically occurs whenever a user attempts to use 2 accounts belonging to the same user in different tabs
       * If the initial roleId at SPA launch time does not match the currently authenticated role
       * we redirect the user to the root page and turn off error reporting
       */
      const currentRoleNotEqualToInitial = roleId && result?.authentication?.roleId !== roleId;

      if (currentRoleNotEqualToInitial) {
        turnOffErrorReporting();
      }

      const hasRole = !!result?.authentication?.role;

      if ((!hasRole || currentRoleNotEqualToInitial) && !isDevelopment()) {
        window.location.replace("/");
      }

      return result;
    });
  });
};
